import { networkGroup } from './utils'

const loaded = state => state.auth.loaded
const data = state => state.auth.data
const tokenerror = state => state.auth.tokenerror
const isAdmin = state => {
  const data = state.auth.data
  if(!data) return false
  if(!data.meta) return false
  return data.meta.admin ? true : false
}

const selectors = {
  loaded,
  data,
  tokenerror,
  isAdmin,
  ...networkGroup('auth', [
    'login',
    'register',
    'updateSettings',
  ])
}

export default selectors
